const SERVICES_AVAILABLE = "/webservice/services-available";
const BOOKING_STATUS = "/webservice/get_booking_statuses";
const CUSTOMERS_AVAILABLE = "/webservice/booking-customer-search";
const USERS_AVAILABLE = "/webservice/get_booking_users";
const USERS_INQUIRY_AVAILABLE = "/webservice/get-inquiry-admin-users";
const TRADING_NAMES = "/webservice/trading-names-available";
const GET_DROP_DOWN_ACTIONS_URL = "/webservice/get-customer-dropdowns";
const GET_CUSTOMER_ADDRESS = "/common/booking-address";
const GET_CUSTOMER_ADDRESSES = "/webservice/customer/get-customer-address";
const GET_CUSTOMER_TIMEZONES = "/webservice/time-zones";
const GET_CUSTOMER_COUNTRIES = "/webservice/countries-custome";
const GET_LABELS = "/booking/label/get-lables";
const SELECTED_LABELS = "/booking/label/select-label";
const SELECTED_LABELS_FOR_INQUIRY = "/inquiry/label/select-label";
const Create_LABEL = "/booking/label/add-label";
const CREATE_LABEL_FOR_INQUIRY = "/inquiry/label/add-label";
const BOOKING_EDIT_DESCRIPTION = "/booking/edit-description";
const BOOKING_EDIT_OWNER_ID = "/booking/edit-owner-id";
const INQUIRY_ADD_OWNER_ID = "/inquiry/add-owner-id";
const BOOKING_EDIT_TRADING_ID = "/booking/edit-trading-name";
const INQUIRY_EDIT_TRADING_ID = "/inquiry/edit-trading-name";
const BOOKING_EDIT_SOURCE_ID = "/booking/edit-source-id";
const INQUIRY_EDIT_SOURCE_ID = "/inquiry/edit-source-id";
const GET_CONTRACTOR_DATA_BY_ID = "/contractor-details";
const DELETE_CUSTOMER_SIGNTURE = "/destroy-customer-signature";
const EstimateAccept = "/estimate/accept";
const EstimateDecline = "/estimate/decline";

module.exports = {
  getPhotos: function getPhotos(url) {
    return function () {
      return window.axios.get(url);
    };
  },
  getServices: function getServices(business_type, allow_multi_customers = 0) {
    is_products = document.getElementById("isProducts")
      ? document.getElementById("isProducts").value
      : false;
    booking_status = document.getElementById("bookingStatus")
      ? document.getElementById("bookingStatus").value
      : false;
    for_products = is_products && is_products === booking_status;
    return window.axios.get(SERVICES_AVAILABLE, {
      params: {
        business_type: business_type,
        allow_multi_customers: allow_multi_customers,
        for_products: for_products,
      },
    });
  },
  getBookingStatuses: function getBookingStatuses(params) {
    return window.axios.get(BOOKING_STATUS, { params: params });
  },
  getCustomers: function getCustomers(params) {
    return window.axios.get(CUSTOMERS_AVAILABLE, { params: params });
  },
  getUsers: function getUsers(custom_columns_array = null) {
    return window.axios.get(USERS_AVAILABLE, {
      params: { custom_columns_array: custom_columns_array },
    });
  },
  getInquiryAdminUsers: function getInquiryAdminUsers(
    custom_columns_array = null
  ) {
    return window.axios.get(USERS_INQUIRY_AVAILABLE, {
      params: { custom_columns_array: custom_columns_array },
    });
  },
  getTradingNames: function getTradingNames(params) {
    return window.axios.get(TRADING_NAMES, { params: params });
  },
  getCustomerDropDownActions: function getCustomerDropDownActions(customerId) {
    return window.axios.get(GET_DROP_DOWN_ACTIONS_URL, {
      params: { customer_id: customerId },
    });
  },
  getCustomerAddress: function getCustomerAddress(customerId) {
    return window.axios.get(GET_CUSTOMER_ADDRESS, {
      params: { customer_id: customerId, ajax: true },
    });
  },
  getCustomerAddresses: function getCustomerAddress(customerId, inputToSearch) {
    return window.axios.get(GET_CUSTOMER_ADDRESSES, {
      params: {
        customer_id: customerId,
        inputToSearch: inputToSearch,
        for_web: 1,
        ajax: true,
      },
    });
  },
  getCustomerTimeZones: function getCustomerTimeZones(params) {
    return window.axios.get(GET_CUSTOMER_TIMEZONES, { params: params });
  },
  getCustomerCountries: function getCustomerCountries(params) {
    return window.axios.get(GET_CUSTOMER_COUNTRIES, { params: params });
  },
  getTimezones: function getTimezones({ params: params }) {},
  getLabels: function getLabels(params) {
    return window.axios.get(GET_LABELS, { params: params });
  },
  selectedLabelsAction: function selectedLabelsAction(bookingId, label_ids) {
    const formData = new FormData();
    formData.append("id", bookingId);
    formData.append("label_ids_vuejs", label_ids);

    return window.axios.post(
      SELECTED_LABELS + "/" + bookingId + "?color=1",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
  addLabelsToInquiry: function addLabelsToInquiry(inquiryId, label_ids) {
    const formData = new FormData();
    formData.append("id", inquiryId);
    formData.append("label_ids_vuejs", label_ids);

    return window.axios.post(
      SELECTED_LABELS_FOR_INQUIRY + "/" + inquiryId + "?color=1",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
  createLabels: function createLabels(params, bookingId) {
    const formData = new FormData();
    formData.append("label_name", params.labelName);
    formData.append("color_text_input", params.color);
    formData.append("parent_label", params.parentLabel);
    formData.append("id", bookingId);
    formData.append("color", true);

    return window.axios.post(Create_LABEL, formData, {
      headers: {
        "Content-Type": "multipart/form-data", // Use multipart/form-data for FormData
      },
    });
  },
  createLabelsForInquiry: function createLabelsForInquiry(params, inquiryId) {
    const formData = new FormData();
    formData.append("label_name", params.labelName);
    formData.append("color_text_input", params.color);
    formData.append("parent_label", params.parentLabel);
    formData.append("inquiry_id", inquiryId);
    formData.append("color", true);
    formData.append("isAjaxForVue", 1);

    return window.axios.post(
      CREATE_LABEL_FOR_INQUIRY + "/" + inquiryId,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data", // Use multipart/form-data for FormData
        },
      }
    );
  },
  getTimezones: function getTimezones(params) {},
  bookingEditDescription: function bookingEditDescription(
    id,
    description,
    itemtype = "booking"
  ) {
    let formDataInputs = new FormData();
    formDataInputs.append("description", description);
    formDataInputs.append("itemtype", itemtype);
    window.axios
      .post(BOOKING_EDIT_DESCRIPTION + "/" + id, formDataInputs, {
        responseType: "json", // default
      })
      .then(function (response) {
        return response.data;
      });
  },

  bookingEditOwnerId: function bookingEditOwnerId(id, ownerId) {
    let formDataInputs = new FormData();
    formDataInputs.append("created_by", ownerId);
    return window.axios.post(BOOKING_EDIT_OWNER_ID + "/" + id, formDataInputs, {
      responseType: "json", // default
    });
    // return window.axios.post(BOOKING_EDIT_DESCRIPTION + '/' + id, {params: params});
  },
  inquiryAddOwnerId: function inquiryAddOwnerId(id, ownerId) {
    let formDataInputs = new FormData();
    formDataInputs.append("created_by", ownerId);
    return window.axios.post(INQUIRY_ADD_OWNER_ID + "/" + id, formDataInputs, {
      responseType: "json", // default
    });
    // return window.axios.post(BOOKING_EDIT_DESCRIPTION + '/' + id, {params: params});
  },
  bookingEditTradnigNameId: function bookingEditTradnigNameId(
    id,
    TradingNameId
  ) {
    let formDataInputs = new FormData();
    formDataInputs.append("trading_name_id", TradingNameId);
    return window.axios.post(
      BOOKING_EDIT_TRADING_ID + "/" + id,
      formDataInputs,
      {
        responseType: "json", // default
      }
    );
  },
  inquiryEditTradnigNameId: function inquiryEditTradnigNameId(
    id,
    TradingNameId
  ) {
    let formDataInputs = new FormData();
    formDataInputs.append("trading_name_id", TradingNameId);
    return window.axios.post(
      INQUIRY_EDIT_TRADING_ID + "/" + id,
      formDataInputs,
      {
        responseType: "json", // default
      }
    );
  },
  bookingEditSourceId: function bookingEditSourceId(id, sourceId) {
    let formDataInputs = new FormData();
    formDataInputs.append("source_id", sourceId);
    return window.axios.post(
      BOOKING_EDIT_SOURCE_ID + "/" + id,
      formDataInputs,
      {
        responseType: "json", // default
      }
    );
  },
  inquiryEditSourceId: function inquiryEditSourceId(id, sourceId) {
    let formDataInputs = new FormData();
    formDataInputs.append("source_id", sourceId);
    return window.axios.post(
      INQUIRY_EDIT_SOURCE_ID + "/" + id,
      formDataInputs,
      {
        responseType: "json", // default
      }
    );
  },

  saveSelectedLabelsApi: function saveSelectedLabelsApi(url, id, label_ids) {
    const formData = new FormData();
    formData.append("id", id);
    label_ids.forEach((labelId) => {
      formData.append("label_ids[]", labelId);
    });

    return window.axios.post(url + "/" + id + "?color=1", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  createNewLabelApi: function createNewLabelApi(params, url, id) {
    const formData = new FormData();
    formData.append("label_name", params.labelName);
    formData.append("color_text_input", params.color);
    formData.append("parent_label", params.parentLabel);
    formData.append("id", id);
    formData.append("color", true);
    formData.append("vueJs", true);

    return window.axios.post(url + "/" + id + "?color=1", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  bookingEditFieldworker: function bookingEditFieldworker(
    id,
    visitId,
    fieldWorkerId
  ) {
    let formDataInputs = new FormData();
    formDataInputs.append("contractorId", fieldWorkerId);
    formDataInputs.append("visitId", visitId);
    return window.axios.post(
      "/booking/edit-contractor-id" + "/" + id,
      formDataInputs,
      {
        responseType: "json", // default
      }
    );
    // return window.axios.post(BOOKING_EDIT_DESCRIPTION + '/' + id, {params: params});
  },

  getContractorDataById: function getContractorDataById(
    id,
    item_id,
    item_type
  ) {
    let params = {
      contractor_id: id,
      item_id: item_id,
      item_type: item_type,
      forview: 0,
    };
    return window.axios.get(GET_CONTRACTOR_DATA_BY_ID, { params: params });
  },

  deleteCustomerSignatureAction: function deleteCustomerSignatureAction(id) {
    let formDataInputs = new FormData();
    formDataInputs.append("id", id);
    formDataInputs.append("ajax", 1);
    return window.axios.post(
      DELETE_CUSTOMER_SIGNTURE + "/" + id,
      formDataInputs,
      {
        responseType: "json", // default
      }
    );
  },
  quoteStatusChangeApi: function quoteStatusChangeApi(id, ajax_javascript) {
    return window.axios.get(EstimateAccept + "/" + id, {
      params: {
        ajax_javascript: ajax_javascript,
      },
    });
  },

  quoteStatusChangeApiEstimateDecline:
    function quoteStatusChangeApiEstimateDecline(
      id,
      ajax_javascript,
      declineEstimateReason
    ) {
      return window.axios.get(EstimateDecline + "/" + id, {
        params: {
          ajax_javascript: ajax_javascript,
          declineEstimateReason: declineEstimateReason,
        },
      });
    },
};
